// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.REf5q9 {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background: var(--card-background, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));
  overflow: hidden;
}

.HbNMvj {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);
  gap: var(--spacing-3, 24px);
  flex: 1;
  min-height: 0;
}

.ToZgDg {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.IFvb_a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  position: relative;
  background: var(--surface-warning-subtle, rgba(214, 64, 0, 0.1));
}

.NAb_pS {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rlqH0y {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1, 8px);
  max-width: 355px;
  width: 100%;
  text-align: center;
}

.Mqsby6 {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-subtitle-md-semibold-font-weight, 600);
  font-size: var(--type-subtitle-sm-font-size, 14px);
  line-height: var(--type-subtitle-sm-line-height, 1.8);
  color: var(--text-primary, #1f1f1f);
  margin: 0;
  text-align: center;
}

.CfUUPC {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-body-sm-font-weight, 400);
  font-size: var(--type-body-sm-font-size, 14px);
  line-height: var(--type-body-sm-line-height, 1.8);
  color: var(--text-primary, #1f1f1f);
  margin: 0;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .HbNMvj {
    padding: var(--spacing-2, 16px);
    gap: var(--spacing-2, 16px);
  }

  .IFvb_a {
    width: 64px;
    height: 64px;
  }

  .rlqH0y {
    max-width: 280px;
  }

  .Mqsby6 {
    font-size: var(--type-body-sm-font-size, 14px);
  }

  .CfUUPC {
    font-size: var(--type-label-md-font-size, 13px);
  }
}

/* Status-specific styles */
.REf5q9[data-status='completed'] .Mqsby6 {
  color: var(--text-success, #28a745);
}

.REf5q9[data-status='error'] .Mqsby6 {
  color: var(--text-error, #dc3545);
}

.REf5q9[data-status='processing'] .Mqsby6 {
  color: var(--text-info, #17a2b8);
}

/* Animation for processing state */
.CW8_ms .NAb_pS {
  animation: wTeMZu 2s infinite;
}

@keyframes wTeMZu {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/AccountActivationStatus/AccountActivationStatus.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mCAAmC;EACnC,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;EAC7E,2BAA2B;EAC3B,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,8DAA8D;EAC9D,kDAAkD;EAClD,qDAAqD;EACrD,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,8CAA8C;EAC9C,iDAAiD;EACjD,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;EACE,6BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  background: var(--card-background, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));\n  overflow: hidden;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n  gap: var(--spacing-3, 24px);\n  flex: 1;\n  min-height: 0;\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.iconBackground {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  position: relative;\n  background: var(--surface-warning-subtle, rgba(214, 64, 0, 0.1));\n}\n\n.progressIcon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  max-width: 355px;\n  width: 100%;\n  text-align: center;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-subtitle-md-semibold-font-weight, 600);\n  font-size: var(--type-subtitle-sm-font-size, 14px);\n  line-height: var(--type-subtitle-sm-line-height, 1.8);\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n  text-align: center;\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-body-sm-font-weight, 400);\n  font-size: var(--type-body-sm-font-size, 14px);\n  line-height: var(--type-body-sm-line-height, 1.8);\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n  text-align: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .content {\n    padding: var(--spacing-2, 16px);\n    gap: var(--spacing-2, 16px);\n  }\n\n  .iconBackground {\n    width: 64px;\n    height: 64px;\n  }\n\n  .textContainer {\n    max-width: 280px;\n  }\n\n  .title {\n    font-size: var(--type-body-sm-font-size, 14px);\n  }\n\n  .description {\n    font-size: var(--type-label-md-font-size, 13px);\n  }\n}\n\n/* Status-specific styles */\n.container[data-status='completed'] .title {\n  color: var(--text-success, #28a745);\n}\n\n.container[data-status='error'] .title {\n  color: var(--text-error, #dc3545);\n}\n\n.container[data-status='processing'] .title {\n  color: var(--text-info, #17a2b8);\n}\n\n/* Animation for processing state */\n.iconBackground--processing .progressIcon {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `REf5q9`,
	"content": `HbNMvj`,
	"iconContainer": `ToZgDg`,
	"iconBackground": `IFvb_a`,
	"progressIcon": `NAb_pS`,
	"textContainer": `rlqH0y`,
	"title": `Mqsby6`,
	"description": `CfUUPC`,
	"iconBackground--processing": `CW8_ms`,
	"iconBackgroundProcessing": `CW8_ms`,
	"pulse": `wTeMZu`
};
module.exports = ___CSS_LOADER_EXPORT___;
